/* This file contains functions that call on pd-segment-library that don't rely
 * on calling the Redux store from inside the util file. The tracks that rely on
 * this are also kept in this file as consts.
 *
 * The rationale for this is that calling the store arbitrarily has been a previously
 * known cause of memory leaks. Due to the frequency at which we'll be making Segment
 * calls via the onboarding 3rd arm experiment, it seemed worthwhile to make a separate
 * storeless library for dealing with Segment.
 *
 * This is kept in a separate file because even importing util/segment.js may also invoke
 * the store.
 *
 * Ideally, we should move towards having _ALL_ Segment calls rely on this library to reduce
 * the risk of leaks.
 */

export const TRACKS_THIRD_ARM = {
  get_started: 'EXP-nurturebar_onboarding_getstarted',
  service_created: 'EXP-nurturebar_onboarding_service_created',
  notification_sent: 'EXP-nurturebar_onboarding_notification_sent',
  mobile_app_continue: 'EXP-nurturebar_onboarding_mobileapp_continue',
  schedule_link: 'EXP-nurturebar_onboarding_schedulecreate_clicked',
  integration_link: 'EXP-nurturebar_onboarding_integrations_clicked',
  quit_onboarding: 'EXP-nurturebar_onboarding_finishonboardinglater',
  see_step_again: 'EXP-nurturebar_onboarding_seeitagain',
  nurture_banner: 'EXP-nurturebar_onboarding_clickedbanner',
};

export const trackEvent = (trackName, trackProperties, callback) => {
  try {
    window.pdAnalytics.track(trackName, trackProperties, callback);
  } catch {
    callback();
  }
};
